import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { CustomerPendingApproval } from '../../../../models/customer-pending-approval.model';
import { Customer } from '../../../../models/customer.model';
import { CustomerService } from '../../../../services/customer.service';
import { CustomerPendingApprovalService } from '../../../../services/customer-pending-approval.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-view-customer-pending-approval-modal',
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './view-customer-pending-approval-modal.component.html'
})
export class ViewCustomerPendingApprovalModalComponent implements OnInit, OnChanges {
  @Input() visible = false;
  @Input() customerPendingApproval: CustomerPendingApproval | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() approved = new EventEmitter<void>();
  @Output() rejected = new EventEmitter<void>();

  originalCustomer: Customer | null = null;
  loadingOriginal = false;
  loadingDetails = false;

  constructor(
    private customerService: CustomerService,
    private customerPendingApprovalService: CustomerPendingApprovalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    if (this.visible && this.customerPendingApproval) {
      this.loadData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible'] && changes['visible'].currentValue && this.customerPendingApproval) {
      this.loadData();
    }
  }

  loadData() {
    if (!this.customerPendingApproval) return;

    this.loadingDetails = true;
    this.loadingOriginal = true;

    // Buscar detalhes completos do pendente
    this.customerPendingApprovalService.getById(this.customerPendingApproval.id).subscribe({
      next: (data) => {
        this.customerPendingApproval = data.data;
        this.loadingDetails = false;
      },
      error: () => {
        this.loadingDetails = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar os detalhes do cadastro pendente'
        });
      }
    });

    // Buscar cliente original pelo CPF
    // Assumindo que existe um método para buscar por CPF, caso contrário precisaremos criar
    this.customerService.getByCpf(this.customerPendingApproval.customerCpf).subscribe({
      next: (data) => {
        // Encontrar o cliente com o CPF exato
        console.log(data.data);
        const customer = data.data;
        this.originalCustomer = customer || null;
        this.loadingOriginal = false;
      },
      error: () => {
        this.loadingOriginal = false;
        // Não é erro se não encontrar, pode ser um cliente novo
      }
    });
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.originalCustomer = null;
  }

  approve() {
    if (!this.customerPendingApproval) return;

    this.confirmationService.confirm({
      message: `Deseja realmente aprovar o cadastro de ${this.customerPendingApproval.customerFullName}?`,
      header: 'Confirmar Aprovação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.customerPendingApprovalService.approve(this.customerPendingApproval!.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Cadastro aprovado com sucesso'
            });
            this.approved.emit();
            this.close();
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao aprovar o cadastro'
            });
          }
        });
      }
    });
  }

  reject() {
    if (!this.customerPendingApproval) return;

    this.confirmationService.confirm({
      message: `Deseja realmente rejeitar o cadastro de ${this.customerPendingApproval.customerFullName}?`,
      header: 'Confirmar Rejeição',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.customerPendingApprovalService.reject(this.customerPendingApproval!.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Cadastro rejeitado com sucesso'
            });
            this.rejected.emit();
            this.close();
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao rejeitar o cadastro'
            });
          }
        });
      }
    });
  }
}

